<template>
    <div id="app">
        <router-view />
    </div>
</template>

<script>
export default {
    name: "App",
    data() {
        return {};
    },
    mounted() {
        
    },
    methods: {
        
    },
};
</script>

<style>
#app {
    background-color: #f2f2f2;
    margin: 0;
}
* {
    margin: 0;
    padding: 0;
    border: 0;
}
</style>



// WEBPACK FOOTER //
// src/App.vue